<div>
  <div style="margin: 0.5em; padding: 2em 0 1em 0" class="light-blue-text laheta-title">Aiemmin lähetetyt sähköpostit</div>

  @if (sentThisTilikausiObservable | async; as sentThisTilikausi) {
    @if (!sentThisTilikausi?.length) {
      <div>
        <div style="margin-left: 35px">Tilikaudella ei ole vielä lähetetty yhtään sähköpostia.</div>
      </div>
    }
    @for (item of sentThisTilikausi; track item) {
      <div class="laheta-card">
        <div class="laheta-body laheta-body-history">
          <mat-form-field style="margin-bottom: 15px">
            <mat-label>Vastaanottajat</mat-label>
            <input disabled="true" type="text" [value]="item.recipientsEmails" matInput />
          </mat-form-field>
          <mat-form-field style="margin-bottom: 15px">
            <mat-label>Aihe</mat-label>
            <input disabled="true" type="text" [value]="item.aihe" matInput />
          </mat-form-field>
          <div class="history-text">
            <span class="history-text-label">Teksti</span>
            <div [innerHTML]="item.teksti"></div>
          </div>
          @if (item.liitaTuloslaskelma || item.liitaVirallinenTuloslaskelma || item.liitaVirallinenTase || item.liitaVeroilmoitus || item.liitaTaseErittely || (item.liitteetPromise | async)?.length) {
            <div style="margin-top: 10px">
              <span style="color: grey">Liitteet</span>
              <div class="history-liite-wrapper">
                @if (item.liitaTuloslaskelma) {
                  <li class="history-liite" (click)="downloadSentReport(item.avain, 'tuloslaskelma')">tuloslaskelma.pdf</li>
                }
                @if (item.liitaVirallinenTuloslaskelma) {
                  <li class="history-liite" (click)="downloadSentReport(item.avain, 'virallinen-tulos')">virallinen-tulos.pdf</li>
                }
                @if (item.liitaVirallinenTase) {
                  <li class="history-liite" (click)="downloadSentReport(item.avain, 'virallinen-tase')">virallinen-tase.pdf</li>
                }
                @if (item.liitaVeroilmoitus) {
                  <li class="history-liite" (click)="downloadSentReport(item.avain, 'veroilmoitus')">veroilmoitus.pdf</li>
                }
                @if (item.liitaTaseErittely) {
                  <li class="history-liite" (click)="downloadSentReport(item.avain, 'tase-erittely')">tase-erittely.pdf</li>
                }
                @for (liite of item.liitteetPromise | async; track liite) {
                  <li class="history-liite" (click)="downloadAttachment(liite)">{{ liite.nimi }}</li>
                }
              </div>
            </div>
          }
        </div>
        <div class="history-title light-blue-text">{{ item.nimi }} {{ item.luotuDateStr }}</div>
      </div>
    }
  } @else {
    <div style="display: flex; height: 200px; justify-content: center; align-items: center">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  }
</div>
